<template>
  <BaseButton :loading="isSaving" variant="primary" @click="onClick">
    {{ canSave ? 'Save' : 'Save & Next' }}
  </BaseButton>
</template>

<script>
import Vue from 'vue'
import { defineComponent, computed, inject, ref } from '@vue/composition-api'

import { LincolnGlobalUMRService } from '@services'
import { BaseButton } from '@components/base'

export default defineComponent({
  name: 'BDXWizardSaveButton',
  components: {
    BaseButton
  },
  setup() {
    const { id, columns, emit } = inject('bdx-wizard')
    const { activeStep, setActiveStep, validSteps } =
      inject('bdx-wizard--steps')
    const { setErrors } = inject('bdx-wizard--errors')

    const isSaving = ref(false)

    const rlsData = computed(() => {
      const {
        Broker,
        Coverholder_Name,
        Currency,
        TPA_Name,
        Underwriter_Follower,
        Underwriter_Lead
      } = columns.value || {}

      return ('number' === typeof id.value ? [id.value] : id.value).map(
        (item) => ({
          id: item,
          rls_broker: Broker || [],
          rls_coverholder: Coverholder_Name || [],
          rls_tpa: TPA_Name || [],
          underwriter_lead: Underwriter_Lead || [],
          underwriter_follower: Underwriter_Follower || [],
          currency_type: Currency || 'USD'
        })
      )
    })

    const canSave = computed(
      () => validSteps.value.length - 1 === activeStep.value
    )

    const handleSave = async () => {
      isSaving.value = true

      setErrors([])

      try {
        await LincolnGlobalUMRService.update(rlsData.value, {
          transformResponse: [
            (res) =>
              JSON.stringify({
                ...JSON.parse(res),
                noToastError: true
              })
          ]
        })

        isSaving.value = false

        emit('saved')

        Vue.prototype.$toasted.show('Saved successfully.')
      } catch (e) {
        const { data } = e.response || {}
        const { data: error } = JSON.parse(data) || {}

        if (!!error) {
          const newErrors = Array.from(Object.values(error), (errorList) => {
            const [errorKey] = Object.keys(errorList)

            if ('tpa_name' === errorKey) {
              return 'TPA Name is a required field.'
            } else if ('underwriter_lead' === errorKey) {
              return 'Underwriter Lead is a required field.'
            } else if ('underwriter_follower' === errorKey) {
              return 'Underwriter Follower is a required field.'
            } else if ('coverholder' === errorKey) {
              return 'Coverholder is a required field.'
            } else if ('broker' === errorKey) {
              return 'Broker is a required field.'
            } else {
              return 'Something went wrong.'
            }
          })

          setErrors(newErrors)
        }

        isSaving.value = false
      }
    }

    const onClick = async () => {
      if (canSave.value) {
        await handleSave()
      } else {
        const newActiveStep = activeStep.value + 1

        setActiveStep(newActiveStep)
      }
    }

    return {
      activeStep,
      validSteps,

      isSaving,
      canSave,

      onClick
    }
  }
})
</script>
